export const previewDateHints = {
  singleActive: '<bold>{{block}}</bold> activado.',
  singleInactive: '<bold>{{block}}</bold> no está activo en esta fecha.',
  twoBlocksActive: '<bold>{{firstBlock}}</bold> y <bold>{{secondBlock}}</bold> se activan según esta fecha.',
  twoBlocksPartial:
    '<bold>{{activeBlock}}</bold> activado. <bold>{{inactiveBlock}}</bold> no está activo en esta fecha.',
  twoBlocksInactive: '<bold>{{firstBlock}}</bold> y <bold>{{secondBlock}}</bold> no están activos en esta fecha.',
  allActive: 'Los {{totalCount}} bloques con condiciones de fecha se activan según esta fecha.',
  someActive: '{{activeCount}} de {{totalCount}} bloques con condiciones de fecha se activan según esta fecha.',
  noneActive: 'Ninguno de los {{totalCount}} bloques con condiciones de fecha está activo en esta fecha.',
}
